/* ForesightSA hero dashboard deck: stacked cards that change over on their own; a tab or dot jumps to a card and the rotation carries on from there. */
(function () {
  var W = 820, H = 500, EVERY = 2500;
  var T = ['translate(0,0)', 'translate(15px,-15px) scale(.97)', 'translate(30px,-30px) scale(.94)', 'translate(45px,-45px) scale(.91)'];
  var OP = [1, .92, .75, .5];

  function init(root) {
    if (!root || root.dataset.dkReady) return;
    root.dataset.dkReady = '1';
    var cards = [].slice.call(root.querySelectorAll('.dk-card'));
    var n = cards.length;
    if (!n) return;
    var dots = root.querySelector('.dk-dots');
    var flb = root.querySelector('.dk-flb'), fls = root.querySelector('.dk-fls');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0, timer = null, chipT = null;

    [].forEach.call(root.querySelectorAll('td.vb'), function (td) {
      var p = +td.dataset.p, w = Math.round(Math.abs(p) / 18.7 * 62);
      td.innerHTML = '<svg viewBox="0 0 140 14" style="height:14px;display:block" aria-hidden="true"><line x1="70" y1="0" x2="70" y2="14" stroke="#252423"/><rect class="dk-hbar" x="' + (p < 0 ? 70 - w : 70) + '" y="2" width="' + w + '" height="10" fill="' + (p < 0 ? '#c0392b' : '#2E9E6B') + '" style="transform-origin:' + (p < 0 ? 'right' : 'left') + '"/></svg>';
    });

    dots.innerHTML = '';
    cards.forEach(function (c, j) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Show ' + (c.dataset.label || ('card ' + (j + 1))));
      b.addEventListener('click', function () { go(j); });
      dots.appendChild(b);
    });

    function fit() {
      var s = cards[0].clientWidth / W;
      cards.forEach(function (c) {
        var box = c.querySelector('.dk-bd'), scr = box && box.querySelector('.dk-scr');
        if (!scr) return;
        scr.style.transform = 'scale(' + s + ')';
        box.style.height = Math.round(H * s) + 'px';
      });
      var stage = root.querySelector('.dk-stage');
      if (stage) stage.style.height = (cards[0].offsetTop + cards[0].offsetHeight + 33) + 'px';
    }

    function count(el) {
      var v = +el.dataset.v, d = +el.dataset.d, p = el.dataset.p || '', s = el.dataset.s || '';
      if (reduce) { el.textContent = p + v.toFixed(d) + s; return; }
      var t0 = performance.now();
      (function f(t) {
        var k = Math.min(1, (t - t0) / 800), e = 1 - Math.pow(1 - k, 3);
        el.textContent = p + (v * e).toFixed(d) + s;
        if (k < 1) requestAnimationFrame(f);
      })(t0);
    }

    function render() {
      cards.forEach(function (c, i) {
        var pos = (i - idx + n) % n, q = Math.min(pos, T.length - 1);
        c.style.transform = T[q];
        c.style.opacity = pos < T.length ? OP[q] : 0;
        c.style.zIndex = 10 - pos;
        c.setAttribute('aria-hidden', pos ? 'true' : 'false');
        c.classList.remove('go');
      });
      var a = cards[idx];
      void a.offsetWidth;
      a.classList.add('go');
      [].forEach.call(a.querySelectorAll('.num'), count);
      if (flb) flb.textContent = a.dataset.flTitle || '';
      if (fls) fls.textContent = a.dataset.flText || '';
      [].forEach.call(dots.children, function (b, j) { b.classList.toggle('on', j === idx); });
      clearTimeout(chipT);
      [].forEach.call(root.querySelectorAll('.dk-st'), function (s) { s.classList.remove('ok'); s.textContent = 'Submitted'; });
      [].forEach.call(root.querySelectorAll('.dk-approve'), function (b) { b.style.visibility = 'visible'; });
      var st = a.querySelector('.dk-st'), ap = a.querySelector('.dk-approve');
      if (st) chipT = setTimeout(function () { st.classList.add('ok'); st.textContent = 'Approved'; if (ap) ap.style.visibility = 'hidden'; }, 1800);
    }

    function start() { clearInterval(timer); if (n > 1) timer = setInterval(function () { idx = (idx + 1) % n; render(); }, EVERY); }
    function go(j) { idx = j; render(); start(); }
    root.dkGo = go;
    root.dkStop = function () { clearInterval(timer); clearTimeout(chipT); };

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-t]');
      if (t && root.contains(t)) go(+t.dataset.t);
    });
    fit();
    window.addEventListener('resize', fit);
    render();
    start();
  }

  function initAll(scope) { [].forEach.call((scope || document).querySelectorAll('.dk'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor: re-run after a section reloads, and show the card being edited.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { var r = e.target.querySelector('.dk'); if (r && r.dkStop) r.dkStop(); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('.dk-card');
    var root = card && card.closest('.dk');
    if (root && root.dkGo) root.dkGo([].indexOf.call(root.querySelectorAll('.dk-card'), card));
  });
})();
